import { __makeTemplateObject, __assign } from 'tslib';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { backgroundColor, typography, space, layout, borders, overflow, positioning, boxShadow } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';

var defaultStyles = {
  color: "darkMofo",
  fontFamily: "normal",
  fontSize: [1, 2],
  px: ["12px", "15px"],
  py: ["9px", "11px"],
  extra: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    border-radius: 5px;\n    width: 100%;\n    appearance: none;\n    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n      color 0.3s ease-in-out;\n\n    &::placeholder {\n      opacity: 0.5;\n      font-family: inherit;\n      color: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n      box-shadow: 0 0 0 1px ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    border-radius: 5px;\n    width: 100%;\n    appearance: none;\n    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n      color 0.3s ease-in-out;\n\n    &::placeholder {\n      opacity: 0.5;\n      font-family: inherit;\n      color: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n      box-shadow: 0 0 0 1px ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.fieldBorder;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.darkMofo;
  }, function (_a) {
    var theme = _a.theme,
      hoverColor = _a.hoverColor;
    return hoverColor && theme.colors[hoverColor] || hoverColor || "#a3a7af";
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.brand;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.brand;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.dorianGray;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.almostWhite;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.fieldBorder;
  })
};
var StyledInput = /*#__PURE__*/styled("input").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Input__StyledInput",
  componentId: "sc-1xpbyak-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), backgroundColor, flexboxes, typography, space, layout, borders, overflow, positioning, boxShadow, function (_a) {
  var extra = _a.extra;
  return extra !== null && extra !== void 0 ? extra : extra;
});
var Input = function (props) {
  return React__default.createElement(StyledInput, __assign({}, defaultStyles, props));
};
var templateObject_1, templateObject_2;

export { Input, StyledInput };
//# sourceMappingURL=Input.js.map
